import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider({ testimonials = [] }) {
  const settings = {
    infinite: false, // Changed to false to stop continuous sliding
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <LogoWrapper key={index} className="flexCenter">
            <TestimonialBox
              text={testimonial.text}
              author={testimonial.author}
              company={testimonial.company}
               url={testimonial.url}
              
            />
          </LogoWrapper>
        ))}
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;